// Create a tooltip directive
const tooltipDirective = {
    mounted(el, binding) {
        const tooltip = new bootstrap.Tooltip(el, {
            trigger: 'hover',
            title: binding.value || '', // Use bound value as tooltip text if provided
            ...binding.modifiers   // Allow for modifier options
        });

        // Store tooltip instance on the element
        el._tooltip = tooltip;

        // Add click handler to hide tooltip
        el.addEventListener('click', () => {
            tooltip.hide();
        });
    },
    beforeUnmount(el) {
        // Clean up tooltip when element is removed
        if (el._tooltip) {
            el._tooltip.dispose();
        }
    }
};

export default tooltipDirective;
